import React from 'react';
import Modal from 'react-modal';
import './CSVPopup.scss';

Modal.setAppElement('#root')

const customStyle = {
    overlay: {
        backgroundColor: 'transparent'
        // zIndex: 98,
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        padding: 'none',
        borderRadius: '10px',
        boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.5)'
    },
}

function CSVPopup({ isOpen, onRequestClose, savePeriodData, savePageData, popupType = 'allSelected' }) {
    // popupType: 'noSelection' (아무것도 체크 안함) | 'allSelected' (전체 체크)
    
    const handleConfirm = () => {
        if (savePeriodData) {
            savePeriodData();
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            style={customStyle}
            onRequestClose={onRequestClose}
            shouldCloseOnOverlayClick={false}
        >
            <div className='sumDataModal saveAsCSV'>
                <div className='msg'>
                    {popupType === 'noSelection' ? (
                        <p>선택 기간 전체의 데이터를 저장하시겠습니까?</p>
                    ) : (
                        <p>저장하실 데이터를 선택해 주세요.</p>
                    )}
                </div>
                <div className='btnsArea'>
                    {popupType === 'noSelection' ? (
                        <>
                            <button onClick={handleConfirm}>예</button>
                            <button onClick={onRequestClose}>아니오</button>
                        </>
                    ) : (
                        <>
                            <button onClick={savePeriodData}>선택 기간 전체</button>
                            <button onClick={savePageData}>현재 페이지</button>
                            <button onClick={onRequestClose}>취소</button>
                        </>
                    )}
                </div>
            </div>
        </Modal>
    );
}

export default CSVPopup;